import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { classNames } from '@/utils/classNames'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    children: ReactNode
    fullWidth?: boolean
    variant?: 'solid' | 'outline' | 'ghost'
    leftIcon?: ReactNode
    rightIcon?: ReactNode
    textColor?: string
    borderColor?: string
}

export function Button({
    children,
    fullWidth = false,
    variant = 'solid',
    leftIcon,
    rightIcon,
    textColor,
    borderColor,
    onClick,
    className = '',
    ...props
}: Readonly<ButtonProps>) {
    const baseStyles =
        'cursor-pointer text-sm disabled:bg-neutral-300 disabled:cursor-default rounded-xl py-3 px-4 font-medium flex items-center justify-center gap-1 transition-all'

    const variantStyles = {
        solid: `bg-black border text-${textColor ?? 'white'}`,
        outline: `border border-${borderColor ?? 'black'} text-${
            textColor ?? 'black'
        } bg-transparent`,
        ghost: `text-${textColor ?? 'black'} bg-transparent`,
    }

    return (
        <button
            onClick={onClick}
            className={classNames(
                baseStyles,
                variantStyles[variant],
                fullWidth && 'w-full',
                className
            )}
            {...props}
        >
            {leftIcon && <span>{leftIcon}</span>}
            {children}
            {rightIcon && <span>{rightIcon}</span>}
        </button>
    )
}
